module.exports = __webpack_public_path__ + "img/partenaires-n.b83efa16.png";